export interface DeductionControlProps {
    type: DeductionControlType;
    action: DeductionControlAction;
}

export enum DeductionControlType {
    PRIMARY = "PRIMARY",
    SECONDARY = "SECONDARY",
    TERTIARY = "TERTIARY",
}

export enum DeductionControlAction {
    APPROVE = "APPROVE",
    AWAITING_RESPONSE = "AWAITING_RESPONSE",
    DISPUTE_APPROVED = "DISPUTE_APPROVED",
    DISPUTE_NEEDED = "DISPUTE_NEEDED",
    DISPUTE_REJECTED = "DISPUTE_REJECTED",
    EDIT = "EDIT",
    PUSH_TO_BOOKS = "PUSH_TO_BOOKS",
    RAISE_DISPUTE = "RAISE_DISPUTE",
    REOPEN = "REOPEN",
    RETURN = "RETURN",
    SUBMIT_FOR_APPROVAL = "SUBMIT_FOR_APPROVAL",
    VOID = "VOID",
    WRITE_OFF = "WRITE_OFF",
}

export class DeductionControl implements DeductionControlProps {
    private readonly _type: DeductionControlType;
    private readonly _action: DeductionControlAction;

    constructor(props: DeductionControlProps) {
        this._type = props.type;
        this._action = props.action;
    }

    get type(): DeductionControlType {
        return this._type;
    }

    get action(): DeductionControlAction {
        return this._action;
    }

    static from(props: DeductionControlProps): DeductionControl {
        return new DeductionControl(props);
    }
}